module.exports = __webpack_public_path__ + "files/9258a0302a0235c0466d32bf42c1712c.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/mattermost.png
// module id = 700
// module chunks = 27